export default __webpack_public_path__ + "static/media/digicel.14b50cbe.png";